import { Badge } from "@/components/ui/badge";
import { CheckCircle, Clock, AlertTriangle } from "lucide-react";

interface ReviewStatusBadgeProps {
  status: 'pending' | 'approved' | 'needs_revision';
  className?: string;
}

export const ReviewStatusBadge = ({ status, className }: ReviewStatusBadgeProps) => {
  const statusConfig = {
    pending: {
      label: 'Pending Review',
      variant: 'secondary' as const,
      icon: Clock,
      color: 'text-yellow-600'
    },
    approved: {
      label: 'Approved',
      variant: 'default' as const,
      icon: CheckCircle,
      color: 'text-green-600'
    },
    needs_revision: {
      label: 'Needs Revision',
      variant: 'destructive' as const,
      icon: AlertTriangle,
      color: 'text-red-600'
    }
  };

  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={className}>
      <Icon className={`h-3 w-3 mr-1 ${config.color}`} />
      {config.label}
    </Badge>
  );
};